import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const META = {
  "/": {
    title: "Joseph Poche — Investor · Builder · Operator | Private Equity, Sub-Saharan Africa",
    description: "Joseph Poche — Senior Investment & Strategy Executive. Private Equity, Direct Equity, Infrastructure & Climate Finance across Sub-Saharan Africa. 17+ years, USD 2B+ in transactions, 30+ countries.",
    keywords: "Joseph Poche, private equity Sub-Saharan Africa, infrastructure finance Africa, climate finance, DFI, blended finance, fundraise advisor, expert consultation, investor introductions, Nairobi, Dubai",
  },
  "/press": {
    title: "Press Kit — Joseph Poche | Bio, Portrait & Speaker Resources",
    description: "Press kit for Joseph Poche — official portrait, short and long-form bios, speaking topics and downloadable CV. For journalists, conference organisers and event hosts.",
    keywords: "Joseph Poche press kit, Joseph Poche bio, speaker private equity Africa, CV download",
  },
  "/intros": {
    title: "Expert Consultation — Joseph Poche | Investment Review, Investor Targeting & Warm Intros",
    description: "Get Joseph Poche to review your investment opportunity, identify the right investors and make warm introductions. From free Discovery to $100k engagements. 1–5% fundraise success fee on capital raised.",
    keywords: "fundraise advisor Africa, investor introductions PE, capital raise consulting, due diligence advisor, M&A advisor Sub-Saharan Africa, fundraise success fee, expert consultation",
  },
  "/endorsements": {
    title: "Endorsements — Joseph Poche | Peer & Counterparty Testimonials",
    description: "Public endorsements from peers, counterparties and portfolio operators on Joseph Poche's work across private equity and infrastructure finance in Sub-Saharan Africa.",
    keywords: "Joseph Poche reviews, testimonials private equity Africa, endorsements",
  },
  "/endorse": {
    title: "Submit an Endorsement — Joseph Poche",
    description: "Leave a short, public endorsement based on your professional experience with Joseph Poche.",
    noindex: true,
  },
  "/privacy": {
    title: "Privacy & Cookies — Joseph Poche",
    description: "How this site handles personal data, cookies, analytics and payments. Plain English.",
  },
  "/login": {
    title: "Sign in — Joseph Poche CRM",
    description: "Private sign-in for the Joseph Poche CRM.",
    noindex: true,
  },
};

function setMeta(name, content, isProperty = false) {
  const attr = isProperty ? "property" : "name";
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

const DEFAULT_ROBOTS = "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1";

export default function SEO() {
  const location = useLocation();

  useEffect(() => {
    // Dashboard is already disallowed in robots.txt — keep meta noindex too as belt-and-braces.
    if (location.pathname.startsWith("/dashboard")) {
      setMeta("robots", "noindex, nofollow");
      return;
    }

    const path = location.pathname.replace(/\/$/, "") || "/";
    const meta = META[path] || META["/"];
    const url = `https://poche.info${path === "/" ? "/" : path}`;

    document.title = meta.title;
    setMeta("description", meta.description);
    if (meta.keywords) setMeta("keywords", meta.keywords);
    setMeta("robots", meta.noindex ? "noindex, nofollow" : DEFAULT_ROBOTS);
    setMeta("og:title", meta.title, true);
    setMeta("og:description", meta.description, true);
    setMeta("og:url", url, true);
    setMeta("twitter:title", meta.title);
    setMeta("twitter:description", meta.description);
    setCanonical(url);
  }, [location.pathname]);

  return null;
}
